module.exports = __webpack_public_path__ + "img/pink-user-circle-20x20.2c8b1d70.svg";